export const HTML_REQUEST = "HTML_REQUEST";
export const HTML_SUCCESS = "HTML_SUCCESS";
export const HTML_FAILURE = "HTML_FAILURE";
export const HTMLFORM_REQUEST = "HTMLFORM_REQUEST";
export const HTMLFORM_SUCCESS = "HTMLFORM_SUCCESS";
export const HTMLFORM_FAILURE = "HTMLFORM_FAILURE";
